// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCache } from '../../DataCache';
import { BrandingToolLinkGenerator } from './Branding/BrandingToolLinkGenerator';
import { BaseExtLink } from './BaseExtLink';
import { ResourcesManager } from '../../properties/ResourcesManager';
export class TradingCentralExtLink extends BaseExtLink {
    constructor() {
        super(...arguments);
        this.tradingCentralTAAddress = '';
        this.tradingCentralAlertAddress = '';
        this.tradingCentralCandlestickAddress = '';
        this.tradingCentralPartner = '';
        this.tradingCentralToken = '';
        this.tcrpPartnerID = '';
        this.tcrpEncryptionKey = '';
        this.clientUserInternalBrowser = true;
    }
    // Override method
    update(brandingTool, extLinkMessage) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        super.update(brandingTool, extLinkMessage);
        if (brandingTool) {
            this.tradingCentralTAAddress = (_a = brandingTool.technicalAnalysis) !== null && _a !== void 0 ? _a : this.tradingCentralTAAddress;
            this.tradingCentralAlertAddress = (_b = brandingTool.alerts) !== null && _b !== void 0 ? _b : this.tradingCentralAlertAddress;
            this.tradingCentralCandlestickAddress = (_c = brandingTool.candlestick) !== null && _c !== void 0 ? _c : this.tradingCentralCandlestickAddress;
            this.tradingCentralPartner = (_d = brandingTool.partnerID) !== null && _d !== void 0 ? _d : this.tradingCentralPartner;
            this.tradingCentralToken = (_e = brandingTool.token) !== null && _e !== void 0 ? _e : this.tradingCentralToken;
            this.tcrpPartnerID = (_f = brandingTool.tcrpPartnerID) !== null && _f !== void 0 ? _f : this.tcrpPartnerID;
            this.tcrpEncryptionKey = (_g = brandingTool.tcrpEncryptionKey) !== null && _g !== void 0 ? _g : this.tcrpEncryptionKey;
            this.urlStr = (_h = brandingTool.tcrpUrl) !== null && _h !== void 0 ? _h : this.urlStr;
        }
        if (extLinkMessage) {
            this.clientUserInternalBrowser = (_j = extLinkMessage.UseInternalBrowser) !== null && _j !== void 0 ? _j : this.clientUserInternalBrowser;
        }
    }
    // Override method
    generateUrl() {
        const userID = DataCache.getUserID();
        if (userID) {
            const tcrpUrl = BrandingToolLinkGenerator.generateTCRPLink(this.urlStr, this.tcrpPartnerID, userID, ResourcesManager.extLinkLocaleName(), this.tcrpEncryptionKey);
            if (tcrpUrl) {
                this.url = tcrpUrl;
                if (this.updateValue) {
                    this.updateValue(tcrpUrl);
                }
            }
        }
    }
}
